import { defineComponent as _defineComponent } from 'vue'
import {useTransactionContextStore} from "@/store/transactionContext.store";
import {usePublicSalesStore} from "@/store/publicSales.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'FiatPaymentConfirmationView',
  setup(__props, { expose: __expose }) {
  __expose();


const transactionContextStore = useTransactionContextStore();

const onPay = () => {
  if(transactionContextStore.paymentCurrency){
    usePublicSalesStore().initPaymentSession({orderId: transactionContextStore.orderId, offeredCurrencyCode: transactionContextStore.paymentCurrency, offeredAmount: Number((Math.round(Number(transactionContextStore.amountToPay.amount.toString()) * 100) / 100).toFixed(2))})
      .then(transactionId => {
        if(transactionId) {
          window.dispatchEvent(
            new CustomEvent('ari10-widget-start-commodities-payment-request', {
              detail: {
                transactionId: transactionId,
              }
            })
          );
        }
      });
  }
};

const __returned__ = { transactionContextStore, onPay }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})